import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SubheadlineVariant {
  variant: string;
  subheadlineText: string;
}

export const useRandomSubheadline = (): SubheadlineVariant => {
  const { t } = useTranslation();
  const [variant, setVariant] = useState<string>('');
  const [subheadlineText, setSubheadlineText] = useState<string>('');

  useEffect(() => {
    // Seleciona variante aleatória sempre a cada refresh
    const variants = ['v1', 'v2', 'v3', 'v4'];
    const selectedVariant = variants[Math.floor(Math.random() * variants.length)];
    
    // Atualiza sessionStorage para tracking de conversão
    sessionStorage.setItem('subheadline_variant', selectedVariant);
    console.log('Subheadline: New variant selected', selectedVariant);
    
    // Dispara tracking
    dispatchTracking(selectedVariant);
    
    setVariant(selectedVariant);
    const text = t(`hero.subheadlineVariants.${selectedVariant}`);
    setSubheadlineText(text);
  }, [t]);

  const dispatchTracking = (variantId: string) => {
    const variantText = t(`hero.subheadlineVariants.${variantId}`);
    const language = localStorage.getItem('i18nextLng') || 'pt-BR';
    
    // Google Analytics 4
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'subheadline_variant_viewed', {
        variant_id: variantId,
        variant_text: variantText,
        language: language,
        experiment_name: 'subheadline_ab_test',
      });
      console.log('GA4 tracking: subheadline_variant_viewed', variantId);
    }
    
    // Google Tag Manager
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'subheadline_experiment',
        variant_id: variantId,
        variant_text: variantText,
        language: language,
      });
      console.log('GTM tracking: subheadline_experiment', variantId);
    }
    
    // Mixpanel - Register as Super Property
    if (typeof window !== 'undefined' && (window as any).mixpanel) {
      (window as any).mixpanel.register({
        subheadline_variant: variantId,
      });
      (window as any).mixpanel.track('Subheadline Variant Viewed', {
        variant_id: variantId,
        variant_text: variantText,
        language: language,
      });
      console.log('Mixpanel tracking: Subheadline Variant Viewed', variantId);
    }
  };

  return { variant, subheadlineText };
};
